import mailStore from '../store/Store';
import type ConversationItemParts from '../store/schema/ConversationItemParts';

const MAX_ITEMS_ALLOWED_TO_RETRIEVE = 100; // GCI has a limit of 100 items allowed to retrieve

export default function canConversationLoadMore(conversationId: string): boolean {
    const conversationItemParts: ConversationItemParts | undefined =
        mailStore().conversations.get(conversationId);

    // Conversation can load more if it has not reached the max items limit and canLoadMore is true
    return (
        !!conversationItemParts &&
        conversationItemParts.maxItemsToReturn < MAX_ITEMS_ALLOWED_TO_RETRIEVE &&
        !!conversationItemParts?.canLoadMore
    );
}
